import type { PropsWithChildren } from 'react';
import { ErrorBoundary } from 'react-error-boundary';

/**
 * Wraps a data-driven instruction block in an error boundary so a failed context
 * fetch (e.g. CDF unavailable) degrades the block to absent instead of throwing
 * through the chat's Suspense boundary and crashing the chat.
 *
 * Loading (Suspense) still bubbles up to the chat's boundary so the composer
 * stays gated until the prompt is complete; only thrown errors are caught here,
 * and the failed block renders nothing.
 */
export function SafeInstructions({ children }: PropsWithChildren) {
  return (
    <ErrorBoundary
      fallbackRender={() => null}
      onError={(error: unknown) =>
        console.error('[instructions] failed to load instruction context; degrading to absent', error)
      }
    >
      {children}
    </ErrorBoundary>
  );
}
